export default __webpack_public_path__ + "static/media/Electricity_00.2acd3b96.png";